import { Injectable, signal } from '@angular/core';

/**
 * Service centralizado para detectar tipo de dispositivo
 * Usa Signal para reatividade em toda a aplicação
 */
@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private readonly MOBILE_BREAKPOINT = 768; // px

  private _isMobile = signal(this.checkMobile());
  private _isTablet = signal(this.checkTablet());

  /**
   * Signal readonly que indica se o dispositivo é mobile (< 768px)
   */
  $isMobile = this._isMobile.asReadonly();

  /**
   * Signal readonly que indica se o dispositivo é tablet (768px - 1024px)
   */
  $isTablet = this._isTablet.asReadonly();

  /**
   * Signal readonly que indica se o dispositivo é desktop (>= 1024px)
   */
  $isDesktop = signal(this.checkDesktop()).asReadonly();

  constructor() {
    this.initResizeListener();
  }

  /**
   * Verifica se é mobile (largura < 768px)
   */
  private checkMobile(): boolean {
    return window.innerWidth < this.MOBILE_BREAKPOINT;
  }

  /**
   * Verifica se é tablet (768px <= largura < 1024px)
   */
  private checkTablet(): boolean {
    return window.innerWidth >= 768 && window.innerWidth < 1024;
  }

  /**
   * Verifica se é desktop (largura >= 1024px)
   */
  private checkDesktop(): boolean {
    return window.innerWidth >= 1024;
  }

  /**
   * Escuta redimensionamento da janela e atualiza os signals
   */
  private initResizeListener(): void {
    window.addEventListener('resize', () => {
      this._isMobile.set(this.checkMobile());
      this._isTablet.set(this.checkTablet());
    });
  }

  /**
   * Retorna o tipo de dispositivo como string
   */
  getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    if (this.$isMobile()) return 'mobile';
    if (this.$isTablet()) return 'tablet';
    return 'desktop';
  }
}
